<template>
    <div class="block">
        <label><i class="el-icon-location-information"></i>:</label>
        <el-popover ref="popover1" placement="bottom-start" width="600px" trigger="click">
            <template #reference>
                <el-button size="small">{{ entity.EntityName }}</el-button>
            </template>
            <div style="width: 600px">
                <div style="padding: 10px">
                    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                </div>
                <el-tree
                    class="my-tree"
                    ref="tree"
                    style="margin-top: 5px"
                    :data="treeData"
                    node-key="EntityID"
                    :current-node-key="entity.EntityID"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    @node-click="onChecked"
                >
                    <template #default="{ data }">
                        <div class="custom-tree-node">
                            <span class="menu-icon icon-org" v-if="data.EntityType == 101"></span>
                            <span class="menu-icon icon-shop" v-if="data.EntityType == 1"></span>
                            <span class="menu-icon icon-floor" v-if="data.EntityType == 2"></span>
                            <span class="menu-icon icon-market" v-if="data.EntityType == 3"></span>
                            <span>{{ data["EntityName"] }}</span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </el-popover>
    </div>
</template>
<script>
import auth from "../scripts/auth";
export default {
    name: "EntityLocation",
    data() {
        return {
            treeData: [],
            entity: {
                EntityID: "",
                EntityName: "",
            },
            filterText: "",
        };
    },
    props: {
        noroot: { type: Boolean, default: false },
    },
    created() {
        let data = auth.getTokenData().Entity;
        this.setEntity(data);
        this.loadData();
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
    methods: {
        setEntity(e) {
            this.entity = e;
            this.$emit("change", this.entity);
        },
        loadData() {
            this.$ajax.post(this.noroot ? "/Entity/GetEntityTree" : "/Entity/GetEntitySelectTree").then((result) => {
                this.treeData = result.Data;
                if (this.noroot && result.Data.length > 0) {
                    this.setEntity(result.Data[0]);
                }
            });
        },
        onChecked(data) {
            this.$refs.popover1.hide();
            this.setEntity(data);
        },
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data["EntityName"].includes(value);
        },
    },
};
</script>
